<template>
  <aside id="notes" @click="hideNotes">
    <nav class="nav is-hidden-tablet" @click.stop>
      <div class="nav__mobile-header">
        <button @click="hideNotes">
          <span class="icon icon--close"></span>
        </button>
        <a title="Home" @click="hideNotes" class="home-link"><logo></logo></a>
      </div>
    </nav>
    <section class="inner" @click.stop>
      <article class="textbody justify-center">
        <section class="h6plus" v-html="html('site.notes-text')"></section>
        <footer>
          <h3>A Note on The Cinemagraphs</h3>
          <section class="h7 nimbus-sans" v-html="html('site.notes-footer')"></section>
          <credits class="is-hidden-tablet"></credits>
        </footer>
      </article>
      <footer class="is-hidden-tablet">
        <app-footer :site="site"></app-footer>
      </footer>
    </section>
  </aside>
</template>

<script>
import Config from 'src/config'
import Logo from './LogoMarque'
import SubscribeForm from './SubscribeForm'
import Credits from 'src/components/Credits'
import AppFooter from './Footer'
export default {
  name: 'notes',
  props: ['mobile', 'site'],
  components: {
    Logo,
    SubscribeForm,
    Credits,
    AppFooter
  },
  data () {
    return {

    }
  },
  computed: {
    mailchimpNewsletterID () {
      return this.site ? this.site.getText('site.mailchimp-newsletter-id') : ''
    }
  },
  methods: {
    html (key) {
      return this.site.getStructuredText(key).asHtml(Config.prismic.links)
    },
    hideNotes () {
      if (this.$route.meta.firstPage) {
        this.$router.push({name: 'Intro'})
      } else {
        this.$router.go(-1)
      }
    }
  },
  created () {
    document.title = 'Notes | ' + Config.title
  }
}
</script>

<style lang="scss">
@import '../style/variables';

#notes{
  @include background(fixed);
  z-index: $z-notes;
  overflow-y:scroll;
  color:$black;
  padding:0 $gutter*2.5;
  cursor:pointer;
  .inner {
    background:$white;
    max-width:35em;
    min-height:100vh;
    margin:0 auto;
    padding:7.875em 4.125em 2.8125em;
    cursor:default;
    display:flex;
    align-items: stretch;
    .flexbox & article {
      display:flex;
      flex-direction:column;
      justify-content:space-between;
    }
    > article{
      > footer{
        margin-top: 3em;
      }
    }
    
  }
  @include on_mobile() {
    padding:0;
    h1,h2,h3,h4,h5,h6{
      margin:3em auto;
      &:first-child{
        margin-top: 0;
      }
    }
    nav{
      .close-btn{
        &:before{
          @include icon(close);
        }
      }
    }
    .inner{
      max-width:none;
      padding: 10.5em 0 0;
      display:block;
      > article{
        display:block;
        padding-left:$collectionMobile-textMargin-ew;
        padding-right:$collectionMobile-textMargin-ew;
        > footer{
          margin:3em auto;
          text-align: center;
        }
      }
    }
    .notes__subscribe{
      padding:0 $collectionMobile-textMargin-ew;
      margin: (318/25)*1em auto 5em;
    }
    .hyphen {
      display:none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// NotesPane.vue?1130c539